import Cookies from 'js-cookie'
import getLang from '@/lib/getBrowserLang'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    language: getLang(),
    logo: {},
    domain: {}
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    setLanguage: ({ commit }, language) => {
      commit('SET_LANGUAGE', language)
      window.location.reload()
    },
    initLogo: (state, logo) => {
      Object.assign(state.logo, logo)
      document.title = logo.title
      const link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/x-icon'
      link.href = logo.ico
      document.head.appendChild(link)
    },
    initDomain(state, domain) {
      Object.assign(state.domain, domain)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js